import React, { useEffect, useState, } from "react"
import ChartistGraph from "react-chartist";
import { Map, GoogleApiWrapper } from 'google-maps-react';
import GoogleMapReact from 'google-map-react';
import Marker from "./Marker/Marker";
import AdminS from "layouts/AdminS";
import Footer from "components/Footer/Footer";

// import { ToastContainer,toast, Zoom, Bounce } from 'react-toastify';
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios"

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import firebase from "../firebase";

function Dashboard() {

  const getMapOptions = (maps: any) => {

    return {
      disableDefaultUI: true,
      mapTypeControl: true,
      streetViewControl: true,
      styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'on' }] }],
    };
  };

//Stroring Reteriwing Data
const[dataCountTMs,setdataCountTMs]= useState("");
const[dataCountDrivers,setdataCountDrivers]= useState("");
const[dataCountUsers,setdataCountUsers]= useState("");

  const activeTMs = ()=>{
                                                          //Get Statues only equal to 1
    const files = firebase.database().ref("reqforaprooval").orderByChild("Status").equalTo(1);
    files.on('value', (snapshot)=>{
      const userList = snapshot.val();
      const dataList = [];
      for(let id in userList){
        dataList.push({id,...userList[id]});
      }
      setdataCountTMs(dataList.length);
    })
  }

  const activeDrivers = ()=>{
    const files = firebase.database().ref("StaffDriver").orderByChild("Status").equalTo(1);
    files.on('value', (snapshot)=>{
      const userList = snapshot.val();
      const dataList = [];
      for(let id in userList){
        dataList.push({id,...userList[id]});
      }
      setdataCountDrivers(dataList.length); 
    })
  }

  const activeUsers = ()=>{
    const files = firebase.database().ref("user_information").orderByChild("status").equalTo(1);
    files.on('value', (snapshot)=>{
      const userList = snapshot.val();
      const dataList = [];
      for(let id in userList){
        dataList.push({id,...userList[id]});
      }
      setdataCountUsers(dataList.length); 
    })
  }

  // const successToast = () => {
  //   toast("Active TM's",{
  //   //className: "custom-toast",
  //   draggable: true,
  //   position: toast.POSITION.TOP_CENTER,
  //   progressClassName: 'success-progress-bar'
  //   });
  //   };
    // toast.error("OH NO ERROR");
    // toast.success("YOU SUCCESES");
    // toast.info("YOU HAVE BEEN INFORMATIONALIZED");
    // toast.warn("YOU HAVE BEEN WARNED");
    
    // const activeUsers = ()=>{
    //   files.on('value', (snapshot)=>{
    //     const userList = snapshot.val();
    //     const dataList = [];
    //     for(let id in userList){
    //       dataList.push({id,...userList[id]});
    //     }
    //     setdataCountUsers(dataList.length); 
    //   })
    // }
    //Stroring Reteriwing Data
const[userData,setUserData]= useState([]);

useEffect(()=>{

  const files = firebase.database().ref("StaffDriverLocation");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    setUserData(dataList);
    console.log(dataList);
  }) 
    
},[]);
  return (
    <>

<AdminS/>

<br/>


<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  

      <Container fluid>
      <br/>
        <Row>
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="fas fa-taxi"></i>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category">Active TM's</p>
                  
                      {dataCountTMs ? <Card.Title as="h4">{dataCountTMs}</Card.Title>:<Card.Title as="h4">_ _</Card.Title>}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                {/* <ToastContainer /> */}
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  <Button onClick={()=>{ activeTMs();  }}>View Active TM</Button>
                </div>
              </Card.Footer>
            </Card>
          </Col>
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="fas fa-angle-double-right"></i>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category">Active Drivers</p>
                      {dataCountDrivers ? <Card.Title as="h4">{dataCountDrivers}</Card.Title>:<Card.Title as="h4">_ _</Card.Title>}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="far fa-calendar-alt mr-1"></i>
                  <Button onClick={()=>activeDrivers()}>View Active Drivers</Button>
                </div>
              </Card.Footer>
            </Card>
          </Col>
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="fas fa-angle-double-right"></i>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category">Active Users</p>
                      {dataCountUsers ? <Card.Title as="h4">{dataCountUsers}</Card.Title>:<Card.Title as="h4">_ _</Card.Title>}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="far fa-calendar-alt mr-1"></i>
                  <Button onClick={()=>activeUsers()}>View Active Users</Button>
                </div>
              </Card.Footer>
            </Card>
          </Col>
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-favourite-28 text-primary"></i>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category">Followers</p>
                      <Card.Title as="h4">+45K</Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Update now
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
        
        <Row center>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Active Users Behavior</Card.Title>
                <p className="card-category">24 Hours performance</p>
              </Card.Header>
              <Card.Body>
              <Container>
                    <div style={{ height: '100vh', width: '100%' }}>
                    <GoogleMapReact
                    defaultCenter={{ lat: 7.091189883359545, lng: 80.0345320756107 }}
                    defaultZoom={10}
                    yesIWantToUseGoogleMapApiInternals
                    // onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
                    bootstrapURLKeys={{
                        key:'AIzaSyDx_OOD2uFzawFZxj_fXWEM_y7omzZnGGY',
                        language: 'en',
                        
                    }}options={getMapOptions}>
                           {/* <Marker
                            lat={6.985740273499406}
                            lng={79.9272497769583}
                            name="My Marker"
                            color="blue"
                          /> */}
                           <Marker
                            lat={6.9458948}
                            lng={79.9046516}
                            name="My Marker"
                            color="red"
                          />
                           <Marker
                            lat={7.0897143}
                            lng={80.0311356}
                            name="My Marker"
                            color="red"
                          />
                           {/* <Marker
                            lat={6.884148298709535}
                            lng={79.90876272952212}
                            name="My Marker"
                            color="red"
                          /> */}
                           <Marker
                            lat={6.8683279044057315}
                            lng={79.89323467254486}
                            name="My Marker"
                            color="red"
                          />
                            <Marker
                            lat={6.985753956102164}
                            lng={79.92726403102859}
                            name="My Marker"
                            color="red"
                          />
                          
                </GoogleMapReact>
                </div>
            </Container>
            {/* <Table className = "text-center" striped bordered hover> 
        <tbody>{userData.map((data)=>(
            <tr>
            <td>{data.Driver_Latitude}</td>
            <td>{data.Driver_Longitude}</td>
            <td>{data.Driver_Name}</td>
            </tr>
            ))};
        </tbody>
        </Table> */}
              </Card.Body>
            </Card>
          </Col>
          <Col md="4">
            {/* <Card>
              <Card.Header>
                <Card.Title as="h4">Email Statistics</Card.Title>
                <p className="card-category">Last Campaign Performance</p>
              </Card.Header>
              <Card.Body>
                <div
                  className="ct-chart ct-perfect-fourth"
                  id="chartPreferences"
                >
                  <ChartistGraph
                    data={{
                      labels: ["40%", "20%", "40%"],
                      series: [40, 20, 40],
                    }}
                    type="Pie"
                  />
                </div>
                <div className="legend">
                  <i className="fas fa-circle text-info"></i>
                  Open <i className="fas fa-circle text-danger"></i>
                  Bounce <i className="fas fa-circle text-warning"></i>
                  Unsubscribe
                </div>
                <hr></hr>
                <div className="stats">
                  <i className="far fa-clock"></i>
                  Campaign sent 2 days ago
                </div>
              </Card.Body>
            </Card> */}
          </Col>
        </Row>
    
      </Container>

      </Col>
  </Row>

  
</Container>


<Footer /> 

    </>
  );
}

export default Dashboard;
